const AddFolder = ({ title, ...props }) => (
  <svg {...props} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <title>{title}</title>
    <g stroke="none" fill="none" fillRule="evenodd">
      <path
        d="M3.75 5h4.625c.236 0 .458.1.6.271l1.05 1.264h0a.78.78 0 00.6.271h9.625c.414 0 .75.304.75.678v10.839h0c0 .374-.336.677-.75.677H3.75h0c-.414 0-.75-.303-.75-.677V5.677h0C3 5.303 3.336 5 3.75 5z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);

export default AddFolder;
